import axios from "../../axios-auth";
import qs from "qs";
import { i18n, PREFIX } from "../../i18n.js";
import { pathOr } from "ramda";
import constants from "../../helpers/constants";
import hash from "object-hash";

const state = {
  changeOptionsData: {},
  isChangeOptionsLoading: false,
  isPageOptionsLoading: false,
  beforeChangeOptionsCallback: null,
  afterChangeOptionsCallback: null,
  afterChangePageOptionCallback: null,
  onCartSubmitCallback: _ => _,
  showLoginPopupCallback: _ => _,
  addToCartCallbacks: [],
  initFinalizeCallback: null,
  photoMappingCallback: null,
  matrixOneSelection: false,
  callChangeOptions: true,
  quantityCode: null,
  prevChangeOptionsData: null,
  fileCopyChecked: false
};

const getters = {
  getNumberOfHiddenUploads: (state, getters) => {
    const hideUploadRules = getters.getHiddenUploadRules;
    if (hideUploadRules) {
      return Object.keys(hideUploadRules).length;
    }
    return 0;
  },
  getProductPartHiddenUploads: (state, getters) => productPart => {
    if (!!productPart) {
      const hiddenUploads = getters.getHiddenUploadRules;
      return Object.keys(hiddenUploads).includes(productPart)
        ? hiddenUploads[productPart]
        : [];
    }
    return [];
  },
  getHiddenUploadRules: state => {
    return state.changeOptionsData?.hide_upload_rules ?? {};
  },
  getFileCopyChecked: state => {
    return state.fileCopyChecked;
  },
  getSummarySelectedPageOptions: (state, getters) => {
    var summary = [];
    for (let pp in state.changeOptionsData.product_selection.productparts) {
      var ppObj = state.changeOptionsData.product_selection.productparts[pp];
      var data = {};
      for (let pageOptionKey in ppObj.prodpart_options) {
        if (
          getters.getIsCheckedPageOptionActive &&
          !getters.getCheckedInPP({ po_name: pageOptionKey, pp: pp })
        ) {
          continue;
        }
        var item = ppObj.prodpart_options[pageOptionKey];
        if (
          pageOptionKey == "format" &&
          item.po_value.startsWith("Custom format")
        ) {
          data[i18n.t(PREFIX.PO + item.po_name)] = item.po_value.replace(
            "Custom format",
            i18n.t("Custom format")
          );
        } else {
          data[i18n.t(PREFIX.PO + item.po_name)] = i18n.t(
            PREFIX.POV + item.po_value
          );
        }
      }
      if (Object.keys(data).length != 0) {
        var summaryItem = {
          name: i18n.t(PREFIX.PP + ppObj.prodpart_name),
          data
        };

        summary.push(summaryItem);
      }
    }
    return summary;
  },
  getPrevChangeOptionsData: state => {
    return state.prevChangeOptionsData;
  },
  getPersonalizationCustomPrices: state => {
    var prices = {};
    for (var qty in state.changeOptionsData.price_table) {
      if (qty.includes("custom_qty_")) {
        if (
          state.changeOptionsData.price_table[qty].hasOwnProperty(
            "formatted_base_price"
          )
        ) {
          prices[state.changeOptionsData.price_table[qty].quantity] =
            state.changeOptionsData.price_table[qty].formatted_base_price;
        } else {
          prices[state.changeOptionsData.price_table[qty].quantity] = i18n.n(
            state.changeOptionsData.price_table[qty].base_price,
            "currency"
          );
        }
      }
    }

    return prices;
  },
  getQuantityCode: state => {
    return state.quantityCode;
  },
  getChangeOptionsTemplate: state => {
    var template = pathOr(0, ["changeOptionsData", "template"], state);
    if (template && template.length == 0) {
      return 0;
    }
    return template;
  },
  getCallChangeOptions: state => {
    return state.callChangeOptions;
  },
  getMatrixOneSelection: (state, getters) => {
    if (
      [
        "upload_without_configuration",
        "upload_configuration",
        "personalization_configuration",
        "upload_personalization_configuration",
        "upload_personalization_configuration_packaging"
      ].includes(getters.getProductType)
    ) {
      return true;
    }

    if (getters.getIsMobile) {
      if (
        [
          "upload_fullpage_configuration",
          "personalization_fullpage_configuration",
          "upload_personalization_fullpage_configuration"
        ].includes(getters.getProductType)
      ) {
        return true;
      }
    }

    if (getters.getIsSimpleConfigurationProduct) {
      return true;
    }
    return state.matrixOneSelection;
  },
  getPackingTdTexturesFromTemplateMapping: state => {
    return state.changeOptionsData.td_data
      ? state.changeOptionsData.td_data
      : null;
  },

  getSelectedOption: (state, getters) => data => {
    if (getters.getIsMyAccount) {
      return getters.getMyAccountSelection["PP_" + data.pp][data.option];
    } else if (!state.callChangeOptions) {
      return "";
    }
    return state.changeOptionsData.pp_opt["PP_" + data.pp][data.option];
  },
  getQuantity: (state, getters) => {
    if (getters.getPersonalizationQuantityWithPrice) {
      return getters.getQuantityField;
    }
    if (state.changeOptionsData.qty != undefined) {
      return state.changeOptionsData.qty;
    }
    return getters.getQuantityField;
  },
  getSummary: state => {
    var summary = [];
    for (let pp in state.changeOptionsData.product_selection.productparts) {
      var ppObj = state.changeOptionsData.product_selection.productparts[pp];
      var data = {};
      for (let pageOptionKey in ppObj.prodpart_options) {
        var item = ppObj.prodpart_options[pageOptionKey];

        let translation = i18n.t(PREFIX.POV + item.po_value);
        if (translation.startsWith(PREFIX.POV)) {
          translation = item.po_value;
        }
        data[i18n.t(PREFIX.PO + item.po_name)] = translation;
      }
      var summaryItem = {
        name: i18n.t(PREFIX.PP + ppObj.prodpart_name),
        data
      };

      summary.push(summaryItem);
    }
    return summary;
  },
  getPhotoMapping: state => {
    return state.changeOptionsData.photo ? state.changeOptionsData.photo : null;
  },
  getFactsheet: state => {
    return state.changeOptionsData.factsheet_files
      ? state.changeOptionsData.factsheet_files
      : null;
  },
  getDeliveryDate: state => {
    return pathOr(
      "",
      ["changeOptionsData", "information", "delivery_date", "value"],
      state
    ).replaceAll(".", "/");
  },
  getIsChangeOptionsEmpty: state => {
    var no_qty = Object.keys(state.changeOptionsData).filter(el => {
      return el != "qty";
    });
    return no_qty.length == 0;
  },
  getIsPageOptionsLoading: (state, getters) => {
    return getters.getEnableLoader ? state.isPageOptionsLoading : false;
  },
  getBeforeChangeOptionsCallback: state => {
    return state.beforeChangeOptionsCallback;
  },
  getAfterChangeOptionsCallback: state => {
    return state.afterChangeOptionsCallback;
  },
  getAfterChangePageOptionCallback: state => {
    return state.afterChangePageOptionCallback;
  },
  getInitFinalizeCallback: state => {
    return state.initFinalizeCallback;
  },
  getPhotoMappingCallback: state => {
    return state.photoMappingCallback;
  },
  getAddToCartCallbacks: state => {
    return state.addToCartCallbacks;
  },
  getOnCartSubmitCallback: state => {
    return state.onCartSubmitCallback;
  },
  getShowLoginPopupCallback: state => {
    return state.showLoginPopupCallback;
  },
  getChangeOptionsPostData: (
    state,
    getters,
    rootState,
    rootGetters
  ) => makeCall => {
    if (getters.getIsChangeOptionsEmpty) {
      return rootGetters.getInitialChangeOptionsPostData; //getters
    }

    var qties = rootGetters.getCustomQuantitiesLabels;

    let postData = {
      webproduct: rootGetters.getWebProductId,
      qty: state.changeOptionsData.qty,
      custom_quantities: qties.length == 0 ? "" : qties
    };
    if (getters.getStoreCode) {
      postData["store_code"] = getters.getStoreCode;
    }
    if (getters.getAppSelectionId) {
      postData["selection"] = getters.getSelectionId;
    }

    var data = state.changeOptionsData;

    for (let option in data.pp_opt) {
      if (option.startsWith("PP_")) {
        for (let attribute in data.pp_opt[option]) {
          postData[
            "print_options[" + option + "][" + attribute + "][]"
          ] = Array.isArray(data.pp_opt[option][attribute])
            ? data.pp_opt[option][attribute][0]
            : data.pp_opt[option][attribute];
        }
      } else if (option.startsWith("PP")) {
        postData["print_options[" + option + "][]"] =
          rootGetters.getActiveProductPartCode;
      } else if (option.startsWith("spine")) {
        if (typeof data.pp_opt.spine == "object") {
          Object.keys(data.pp_opt.spine).forEach(key => {
            if (data.pp_opt.spine[key] != "") {
              if (typeof data.pp_opt.spine[key] == "object") {
                Object.keys(data.pp_opt.spine[key]).forEach(subkey => {
                  postData[
                    "print_options[spine][" + key + "][" + subkey + "]"
                  ] = data.pp_opt.spine[key][subkey];
                });
              }
            }
          });
        }
      } else {
        if (makeCall) {
          if (Array.isArray(data.pp_opt[option][option])) {
            if (data.pp_opt[option][option].length) {
              postData["print_options[" + option + "][" + option + "]"] =
                data.pp_opt[option][option];
            } else {
              postData["print_options[" + option + "][" + option + "][]"] = "";
            }
          } else {
            postData["print_options[" + option + "][" + option + "][]"] =
              data.pp_opt[option][option];
          }
        } else {
          if (Array.isArray(data.pp_opt[option][option])) {
            if (data.pp_opt[option][option].length) {
              for (var item in data.pp_opt[option][option]) {
                postData[
                  "print_options[" + option + "][" + option + "][" + item + "]"
                ] = data.pp_opt[option][option][item];
              }
            } else {
              postData["print_options[" + option + "][" + option + "][]"] = "";
            }
          } else {
            postData["print_options[" + option + "][" + option + "][]"] =
              data.pp_opt[option][option];
          }
        }
      }
    }

    var preflightInfo = getters.getPreflightSendData;
    postData = { ...postData, ...preflightInfo };

    return postData;
  },
  getChangeOptionsHiddenInputs: (state, getters, rootState, rootGetters) => {
    var data = getters.getChangeOptionsPostData(false);
    delete data.qty; // not needed

    // add new field for packing
    if (getters.getIsPackingEnabled) {
      var packingData = getters.getPackingHiddenInputs;
      data = { ...data, ...packingData };
    }

    if (getters.getShowCostCenter) {
      data["costcenter_number"] = getters.getCostCenter;
    }

    data["has_hidden_upload"] = 0;
    let hiddenUploadRules = getters.getHiddenUploadRules;
    if (Object.keys(hiddenUploadRules).length > 0) {
      data["has_hidden_upload"] = 1;
      const hiddenUploads = getters.getProductPartHiddenUploads(
        getters.getActiveProductPartCode
      );
      data["hidden_product_part"] = hiddenUploads[0];
    }

    /*if (getters.getStoreCode) {
      data["store_code"] = getters.getStoreCode;
    }*/

    return data;
  },
  getChangeOptionsData: state => {
    return state.changeOptionsData;
  },
  getChangeOptionsDataPPOpt: state => {
    return state.changeOptionsData.pp_opt;
  },
  getSelectedFormat: (state, getters) => payload => {
    if (getters.getIsMyAccount) {
      var option = getters.getMyAccountSelection["PP_" + payload].format[0];
      return option;
    }
    return state.changeOptionsData.pp_opt["PP_" + payload].format[0];
  },
  getQuantities: state => {
    var items = [];
    for (var qty in state.changeOptionsData.price_table) {
      var item = {
        code: qty,
        // code: state.changeOptionsData.price_table[qty].quantity,
        ...state.changeOptionsData.price_table[qty]
      };

      if (
        state.changeOptionsData.qty ==
        state.changeOptionsData.price_table[qty].quantity
      ) {
        item["active"] = true;
      }

      items.push(item);
    }

    items.sort(function (a, b) {
      var inta = parseInt(a.quantity);
      var intb = parseInt(b.quantity);
      return inta == intb ? 0 : inta > intb ? 1 : -1;
    });

    return items;
  },
  getHasGrossPrice: state => {
    for (const qty of Object.keys(state.changeOptionsData.price_table)) {
      if (state.changeOptionsData.price_table[qty].gross_price) {
        return true;
      }
      break;
    }
    return false;
  },
  getQuantitiesValues: state => {
    var items = [];
    for (var qty in state.changeOptionsData.price_table) {
      items.push(state.changeOptionsData.price_table[qty].quantity);
    }
    return items;
  },
  getDenyRules: state => {
    return state.changeOptionsData.deny_rules;
  },
  getSelectedQuantityFormattedBasePrice: state => {
    return pathOr("", ["changeOptionsData", "formatted_base_price"], state);
  },
  getProductWeight: state => {
    return pathOr(
      null,
      ["changeOptionsData", "information", "single_item_weight", "value"],
      state
    );
  },
  getProductSpineWidth: state => {
    return pathOr(
      null,
      ["changeOptionsData", "information", "spine_width", "value"],
      state
    );
  },
  getInformation: state => {
    return state.changeOptionsData.information;
  },
  getShowChangeOptionsLoader: (state, getters) => {
    return getters.getEnableLoader ? state.isChangeOptionsLoading : false;
  },
  getIsChangeOptionsLoading: (state, getters) => {
    return state.isChangeOptionsLoading;
  },
  getDenyRulesPoHidden: state => {
    return state.changeOptionsData.deny_rules?.po_hide ?? [];
  }
};

const mutations = {
  setFileCopyChecked: (state, payload) => {
    state.fileCopyChecked = payload;
  },
  setMatrixOneSelection: (state, payload) => {
    state.matrixOneSelection = payload;
  },
  setIsChangeOptionsLoading: (state, payload) => {
    state.isChangeOptionsLoading = payload;
  },

  setPageOption: (
    state,
    { getters, rootState, rootGetters, payload, dispatch }
  ) => {
    var activePageOption = getters.getActivePageOptions;
    if (payload.option) {
      activePageOption = payload.option;
    }

    if (getters.getAfterChangePageOptionCallback) {
      dispatch("callAfterChangePageOptionCallback", {
        value: payload.value,
        option: activePageOption,
        type: "main"
      });
    }
    // array values set ???
    var changeOptionsDataPPOpt = { ...getters.getChangeOptionsDataPPOpt };
    changeOptionsDataPPOpt["PP_" + payload.ppCode][activePageOption] = [
      payload.value
    ];
    if (
      getters.getShouldTransferContentToCover &&
      ["format", "paga_layout", "book_binding"].includes(activePageOption)
    ) {
      if ("content" == getters.getPPContentAttribute(payload.ppCode)) {
        // transfer to cover
        const secondPP = getters.getSecondPP(payload.ppCode);
        changeOptionsDataPPOpt["PP_" + secondPP][activePageOption] = [
          payload.value
        ];
      }
    }
    state.changeOptionsData.pp_opt = changeOptionsDataPPOpt;
  },
  setOtherOption: (state, { getters, payload, dispatch }) => {
    var changeOptionsDataPPOpt = { ...getters.getChangeOptionsDataPPOpt };
    changeOptionsDataPPOpt[payload.option][payload.option] = Array.isArray(
      payload.value
    )
      ? payload.value
      : [payload.value];
    state.changeOptionsData.pp_opt = changeOptionsDataPPOpt;

    if (getters.getAfterChangePageOptionCallback) {
      dispatch("callAfterChangePageOptionCallback", {
        value: payload.value,
        option: payload.option,
        type: "other"
      });
    }
  },
  setChangeOptionsData: (state, payload) => {
    state.changeOptionsData = payload;
  },
  setProductionSpeed: (state, payload) => {
    state.changeOptionsData.pp_opt.production.production[0] = payload;
  },
  setQuantity: (state, payload) => {
    state.changeOptionsData = { ...state.changeOptionsData, qty: payload.qty };
    state.quantityCode = payload.qtyCode;
  },
  setBeforeChangeOptionsCallback: (state, payload) => {
    state.beforeChangeOptionsCallback = payload;
  },
  setAfterChangeOptionsCallback: (state, payload) => {
    state.afterChangeOptionsCallback = payload;
  },
  setAfterChangePageOptionCallback: (state, payload) => {
    state.afterChangePageOptionCallback = payload;
  },
  setInitFinalizeCallback: (state, payload) => {
    state.initFinalizeCallback = payload;
  },
  registerAddToCartCallback: (state, payload) => {
    if (typeof payload === "function")
      state.addToCartCallbacks = [...state.addToCartCallbacks, payload];
  },
  registerOnCartSubmitCallback: (state, payload) => {
    if (typeof payload === "function") state.onCartSubmitCallback = payload;
  },
  registerShowLoginPopupCallback: (state, payload) => {
    if (typeof payload === "function") state.showLoginPopupCallback = payload;
  },
  setPhotoMappingCallback: (state, payload) => {
    state.photoMappingCallback = payload;
  },
  setIsPageOptionsLoading: (state, payload) => {
    state.isPageOptionsLoading = payload;
  },
  setCallChangeOptions: (state, payload) => {
    state.callChangeOptions = payload;
  },
  setPrevChangeOptionsData: (state, payload) => {
    state.prevChangeOptionsData = payload;
  },
  moveToNextStep: (state, { getters, rootState, rootGetters, dispatch }) => {
    // move to the next item activePageOption
    var activePageOption = getters.getActivePageOptions;
    var activePageOptions = { ...rootState.webproduct.activePageOptions };
    var activeProductPageOptionsKyes = Object.keys(
      getters.getActiveProductPageOptions
    );
    var index = activeProductPageOptionsKyes.indexOf(activePageOption);
    if (index > -1) {
      const checkedData = {
        pp: rootState.webproduct.activeProductPartCode,
        po_index: index
      };
      dispatch("setCheckedPOItem", checkedData);

      if (index != activeProductPageOptionsKyes.length - 1) {
        activePageOptions[rootState.webproduct.activeProductPartCode] =
          activeProductPageOptionsKyes[++index];
        rootState.webproduct.activePageOptions = activePageOptions;
      } else {
        // move to the next PP if it exists
        var productPartsCodesKeys = rootGetters.getProductPartsCodes;
        var indexPP = productPartsCodesKeys.indexOf(
          rootState.webproduct.activeProductPartCode
        );
        if (indexPP != -1) {
          if (indexPP != productPartsCodesKeys.length - 1) {
            rootState.webproduct.activeProductPartCode =
              productPartsCodesKeys[++indexPP];
            activePageOptions[
              rootState.webproduct.activeProductPartCode
            ] = Object.keys(getters.getActiveProductPageOptions)[0];
            rootState.webproduct.activePageOptions = activePageOptions;
          } else {
            // finalized selection for all PP
            dispatch("setMatrixComplete", true);
            //rootState.config.showUpload = true;
          }
        }
      }
    }
  }
};

const actions = {
  setFileCopyChecked: ({ commit, getters, dispatch }, payload) => {
    commit("setFileCopyChecked", payload);
    var payloadSet = {};

    let defaultOption =
      getters.getWebProductData !== "undefined" &&
      getters.getWebProductData.options !== "undefined" &&
      getters.getWebProductData.options.options !== "undefined"
        ? getters.getWebProductData.options.options.default_value
        : false;
    let autoSelectOption = "options_extra_file_copy";
    let optionExists = Object.values(
      getters.getWebProductData.options.options.values
    ).some(el => el.value == autoSelectOption);
    if (optionExists) {
      payloadSet.layout = false;
      payloadSet.option = "options";
      payloadSet.optionType = "other";
      if (payload) {
        payloadSet.value = autoSelectOption;
        dispatch("setPageOption", payloadSet);
      } else {
        if (defaultOption) {
          payloadSet.value = defaultOption;
          dispatch("setPageOption", payloadSet);
        }
      }
    }
  },
  setPageOptionFormat: (
    { commit, getters, rootState, rootGetters, dispatch },
    payload
  ) => {
    commit("setPageOption", {
      getters,
      rootState,
      rootGetters,
      payload,
      dispatch
    });
  },
  setPageOption: (
    { commit, getters, rootState, rootGetters, dispatch },
    payload
  ) => {
    commit("setIsPageOptionsLoading", true);
    commit("setMatrixOneSelection", true);
    if (payload.optionType == "main") {
      if (payload.option == rootGetters.getProductPartsOptionCode) {
        commit("setActiveProductPartName", payload.value);
        commit("setIsPageOptionsLoading", false);
        return;
      } else {
        commit("setPageOption", {
          getters,
          rootState,
          rootGetters,
          payload,
          dispatch
        });
        if (getters.getIsPackingEnabled) {
          dispatch("setPackingOption", payload);
          if (getters.getRefreshGetDataPP.includes(payload.option)) {
            dispatch("packingGetData", { callChangeOptions: false });
          }
        }
      }
    } else {
      // other option
      commit("setOtherOption", {
        getters,
        rootState,
        rootGetters,
        payload,
        dispatch
      });
    }
    //----- main will be set into move to next step
    if (payload.optionType !== "quantity") {
      dispatch("changeOptions", payload); // update user options in database
    }
    // will be set in changeOptions
    //commit("setIsPageOptionsLoading", false);
  },
  changeOptions: ({ commit, getters, rootState, dispatch }, payload) => {
    if (!getters.getCallChangeOptions || !getters.getCallChangeOptionPerType) {
      if (payload.initialLoading) {
        dispatch("setIsLoading", false);
        dispatch("callInitialLoadingFinalized", {
          type: "changeOptions",
          status: 1
        });
      }
      return;
    }
    commit("setIsChangeOptionsLoading", true);
    var changeOptionsPostData = getters.getChangeOptionsPostData(true);
    if (getters.getQuantityCode) {
      if (getters.getIsChangeOptionsEmpty)
        changeOptionsPostData["print_options[quantity][quantity][]"] =
          getters.getQuantityCode;
      else
        changeOptionsPostData["print_options[quantity][quantity]"] = [
          getters.getQuantityCode
        ];
    }
    let oldPOValueNeededForGetData = null;
    if (getters.getIsPackingEnabled) {
      oldPOValueNeededForGetData = getters.getPOValueNeededForGetData;
    }
    if (getters.getIsPreflightEnabled) {
      if (
        (getters.getIsUploadedForProductPart(payload.ppCode) &&
          !constants.PREFLIGHT_BLACK_LIST_OPTIONS.includes(
            pathOr(false, ["option"], payload)
          )) ||
        (getters.getIsUploadedForAnyProductPart &&
          ["format", "book_binding"].includes(
            pathOr(false, ["option"], payload)
          ))
      ) {
        getters
          .getSweetAlert({
            icon: "info",
            title: "Parameters have changed",
            showCancelButton: true,
            showConfirmButton: true,
            cancelButtonText: i18n.t("Do nothing"),
            confirmButtonText: i18n.t("Upload new file"),
            onOpen: () => {
              document
                .getElementById("redo-preflight-button")
                .addEventListener("click", () => {
                  if (
                    ["format", "book_binding"].includes(
                      pathOr(false, ["option"], payload)
                    )
                  ) {
                    handleClickSwalCustomButton(
                      "redo-all-preflights",
                      getters,
                      dispatch
                    );
                  } else {
                    handleClickSwalCustomButton(
                      "redo-preflight",
                      getters,
                      dispatch
                    );
                  }
                });
            },
            html: `<button id='redo-preflight-button' class="swal2-styled swal2-custom-upload-button">
              ${i18n.t("Redo preflight check")}
            </button>`
          })
          .then(result => {
            if (result.isConfirmed) {
              dispatch("setDeletedFromSwal", true);
              const productParts = getters.getProductPartsCodes;
              productParts.forEach(pp => {
                if (getters.getIsUploadedForProductPart(pp)) {
                  dispatch("uploadOnDelete", pp);
                }
              });
            } else if (result.isDismissed) {
              //to be done
              console.log("Stop preflight check");
            }
          });
      }
    }
    //cache changeOptions call
    if (hash(changeOptionsPostData) == getters.getPrevChangeOptionsData) {
      // same hash ... no need to call again changeOptions
      commit("setIsChangeOptionsLoading", false);
      commit("setIsPageOptionsLoading", false);
      return;
    }

    commit("setPrevChangeOptionsData", hash(changeOptionsPostData));

    if (getters.getBeforeChangeOptionsCallback) {
      var changeOptionsPostDataResponse = getters.getBeforeChangeOptionsCallback(
        changeOptionsPostData
      );
      if (changeOptionsPostDataResponse) {
        changeOptionsPostData = changeOptionsPostDataResponse;
      }
    }
    axios.instance
      .post(
        getters.getUrl(axios.apiChangeOption),
        qs.stringify(changeOptionsPostData)
      )
      .then(response => {
        if (getters.getAfterChangeOptionsCallback) {
          getters.getAfterChangeOptionsCallback(response.data);
        }

        if (!response.data.success) {
          throw new Error("Could not get prices for selection");
        }
        var responseData = response.data;
        if (
          response.data.hasOwnProperty("success") &&
          response.data.hasOwnProperty("data")
        ) {
          responseData = response.data.data;
        }

        commit("setChangeOptionsData", responseData);
        if (payload.initialLoading) {
          if (getters.getIsPackingEnabled) {
            dispatch("setPreview3DLoading", true);
            dispatch("loadInitialPackingOptions", payload);
            dispatch("packingGetData", {
              callChangeOptions: true,
              setLoading: true
            });
          } else {
            dispatch("setIsLoading", false);
          }
          dispatch("callInitialLoadingFinalized", {
            type: "changeOptions",
            status: 1
          });
        }
        if (getters.getIsLfp) {
          dispatch("parseChangeOptionResponse", responseData);
        }
        if (responseData.preflight_check_updated) {
          dispatch(
            "setPreflightCheckData",
            responseData.preflight_check_updated
          );
        }

        if (getters.getPhotoMappingCallback && getters.getPhotoMapping) {
          getters.getPhotoMappingCallback(getters.getPhotoMapping);
        }

        if (responseData.template) {
          dispatch("setChangeOptionsTemplate", responseData.template);
        }

        if (
          getters.getIsPackingEnabled &&
          JSON.stringify(getters.getCurrentTdData) !=
            JSON.stringify(getters.getTdTexture)
        ) {
          dispatch("setTdImage");
        }

        if (getters.getIsPackingEnabled && !payload.initialLoading) {
          // compare page options required by getDat with the new ones
          // call callChangeOptions false
          const allPageOptions = getters.getAllProductPageOptions(true);
          let getDataCall = false;
          for (let refreshPo in getters.getRefreshGetDataPP) {
            const refreshItem = getters.getRefreshGetDataPP[refreshPo];
            if (
              oldPOValueNeededForGetData[refreshItem] !=
              allPageOptions[refreshItem].selected[0]
            ) {
              dispatch("setPackingOption", {
                value: allPageOptions[refreshItem].selected[0],
                layout: false,
                option: refreshItem,
                optionType: "main"
              });
              getDataCall = true;
            }
          }
          if (getDataCall) {
            getters
              .getSweetAlert({
                text: i18n.t(
                  "Paper was changed. You will need to upload the artwork again!"
                ),
                icon: "warning",
                showCancelButton: false,
                showConfirmButton: true,
                confirmButtonText: i18n.t("Ok")
              })
              .then(userAction => {
                if (userAction.isConfirmed) {
                }
              });
            dispatch("packingGetData", { callChangeOptions: false });
          }
        }

        if (!payload.initialLoading) {
          setDeepLinkUrl(payload, responseData, getters);
        }

        commit("setIsChangeOptionsLoading", false);
        commit("setIsPageOptionsLoading", false);
      })
      .catch(error => {
        console.log(error);
        if (payload.initialLoading) {
          dispatch("setNetworkError", error);
          dispatch("callInitialLoadingFinalized", {
            type: "changeOptions",
            status: 0
          });
          //commit("setIsLoading", false);
        }
        commit("setIsChangeOptionsLoading", false);
        commit("setIsPageOptionsLoading", false);
      });
  },
  setProductionSpeed: ({ commit, getters, dispatch }, payload) => {
    commit("setProductionSpeed", payload);
    dispatch("changeOptions", { option: "production_speed" });
  },
  setQuantityNoChangeOpt: ({ commit, getters, dispatch }, payload) => {
    commit("setQuantity", payload);
  },
  setQuantity: ({ commit, getters, dispatch }, payload) => {
    commit("setQuantity", payload);
    dispatch("changeOptions", {
      value: payload.qtyCode,
      layout: false,
      option: "quantity",
      optionType: "other"
    });
  },
  setBeforeChangeOptionsCallback: ({ commit, getters, dispatch }, payload) => {
    commit("setBeforeChangeOptionsCallback", payload);
  },
  setAfterChangeOptionsCallback: ({ commit, getters, dispatch }, payload) => {
    commit("setAfterChangeOptionsCallback", payload);
  },
  setAfterChangePageOptionCallback: (
    { commit, getters, dispatch },
    payload
  ) => {
    commit("setAfterChangePageOptionCallback", payload);
  },
  callAfterChangePageOptionCallback: (
    { commit, getters, dispatch },
    payload
  ) => {
    if (payload.type == "main") {
      const allPPOptions = getters.getAllProductPageOptions(true);
      if (allPPOptions[payload.option]) {
        const items = allPPOptions[payload.option].values.filter(el => {
          return el.value == payload.value;
        });
        if (items.length > 0) {
          getters.getAfterChangePageOptionCallback({
            ...items[0],
            pp: getters.getActiveProductPartCode,
            option: payload.option,
            multiple: allPPOptions[payload.option].type
          });
        } else {
          if (
            payload.option == "format" &&
            payload.value.startsWith("custom_")
          ) {
            const itemsFormat = getters.getCustomFormats.filter(el => {
              return el.value == payload.value;
            });
            if (itemsFormat.length > 0) {
              getters.getAfterChangePageOptionCallback({
                attributes: {
                  width: "" + itemsFormat[0].width,
                  height: "" + itemsFormat[0].height
                },
                label: itemsFormat[0].label,
                value: payload.value,
                pp: getters.getActiveProductPartCode,
                option: payload.option,
                multiple: allPPOptions[payload.option].type
              });
            }
          }
        }
      }
    } else if (payload.type == "other") {
      const options = getters.getWebProductData.options;
      if (options[payload.option]) {
        let items = options[payload.option].values.filter(el => {
          if (options[payload.option].type == "multiple") {
            return payload.value.includes(el.value);
          } else {
            return el.value == payload.value;
          }
        });
        if (options[payload.option].type == "multiple") {
          var newItems = {};
          for (var idx in items) {
            newItems[items[idx].value] = { ...items[idx] };
          }
          items = [{ attributes: newItems }];
        }

        if (items.length > 0) {
          getters.getAfterChangePageOptionCallback({
            ...items[0],
            pp: null,
            option: payload.option,
            value: payload.value,
            multiple: options[payload.option].type
          });
        }
      }
    }
  },
  setInitFinalizeCallback: ({ commit, getters, dispatch }, payload) => {
    commit("setInitFinalizeCallback", payload);
  },
  registerAddToCartCallback: ({ commit, getters, dispatch }, payload) => {
    commit("registerAddToCartCallback", payload);
  },
  registerOnCartSubmitCallback: ({ commit, getters, dispatch }, payload) => {
    commit("registerOnCartSubmitCallback", payload);
  },
  setPhotoMappingCallback: ({ commit, getters, dispatch }, payload) => {
    commit("setPhotoMappingCallback", payload);
  },
  setCallChangeOptions: ({ commit }, payload) => {
    commit("setCallChangeOptions", payload);
  },
  callInitialLoadingFinalized: ({ getters, dispatch }, payload) => {
    if (payload.type == "changeOptions" && payload.status == 1) {
      dispatch("setListenScroll", true);
    }
    if (getters.getInitFinalizeCallback) {
      getters.getInitFinalizeCallback(payload);
    }
  },
  moveToNextStep: (
    { commit, getters, rootState, rootGetters, dispatch },
    payload
  ) => {
    commit("moveToNextStep", { getters, rootState, rootGetters, dispatch });
    dispatch("changeOptions", payload);
  }
};

const handleClickSwalCustomButton = (payload, getters, dispatch) => {
  switch (payload) {
    case "redo-preflight":
      dispatch("setClickedRedoPreflight", {
        product_part: getters.getPPOfLastChangedPageOption,
        value: true
      });
      const productPartUpload = getters.getUploadForProductPart(
        getters.getPPOfLastChangedPageOption
      );
      if (productPartUpload.uploadedFile) {
        const hash = productPartUpload.uploadedFileHash;
        const name = productPartUpload.uploadedFile;
        dispatch("setFilesStatus", {
          file_name: productPartUpload.uploadedFile,
          status: "PENDING"
        });
        dispatch("pitstopAddFile", {
          hash: hash,
          name: name,
          product_part: getters.getPPOfLastChangedPageOption
        });
      }
      document.body.classList.remove("swal2-shown", "swal2-height-auto");
      document.documentElement.classList.remove(
        "swal2-shown",
        "swal2-height-auto"
      );
      break;
    case "redo-all-preflights":
      const productParts = getters.getAllProductParts;
      productParts.forEach(pp => {
        dispatch("setClickedRedoPreflight", {
          product_part: pp.code,
          value: true
        });
        const productPartUpload = getters.getUploadForProductPart(pp.code);
        if (productPartUpload.uploadedFile) {
          const hash = productPartUpload.uploadedFileHash;
          const name = productPartUpload.uploadedFile;
          dispatch("setFilesStatus", {
            file_name: productPartUpload.uploadedFile,
            status: "PENDING"
          });
          dispatch("pitstopAddFile", {
            hash: hash,
            name: name,
            product_part: pp.code
          });
        }
        document.body.classList.remove("swal2-shown", "swal2-height-auto");
        document.documentElement.classList.remove(
          "swal2-shown",
          "swal2-height-auto"
        );
      });
      break;
    default:
      break;
  }
  const swalModal = document.querySelector(".swal2-container");
  if (swalModal) {
    swalModal.style.display = "none";
  }
};

const setDeepLinkUrl = (payload, responseData, getters) => {
  let payloadSelected = "";
  if (
    typeof payload.optionType !== "undefined" &&
    typeof payload.value !== "undefined"
  ) {
    payloadSelected = payload.value;
  } else {
    return;
  }
  let href = window.location.href;
  let baseUrl = new URL(href);
  let urlSearchParams = new URLSearchParams(decodeURIComponent(baseUrl.search));

  const responseDataOpt = responseData.pp_opt;

  if (payload.optionType == "main") {
    const productParts = getters.getProductPartsCodes;
    const currentPp = getters.getActiveProductPartCode;
    let allPageOpt = {};
    for (let pp in productParts) {
      allPageOpt[productParts[pp]] = getters.getProductPartProductPageOptions(
        productParts[pp]
      );
    }
    const currentPpData = allPageOpt[currentPp];

    for (let opt in currentPpData) {
      let selectedVal = responseDataOpt["PP_" + currentPp][opt][0];

      if (payloadSelected === selectedVal) {
        let newVal = "";
        for (let pp in productParts) {
          let currentResponseData = responseDataOpt["PP_" + productParts[pp]];
          if (typeof currentResponseData[opt] !== "undefined") {
            newVal += currentResponseData[opt][0] + ";";
          }
        }
        urlSearchParams.set(opt, newVal.slice(0, -1));
      }
    }
  } else if (payload.optionType == "other") {
    const optChanged = payload.option ?? "";

    if (typeof responseDataOpt[optChanged] !== "undefined") {
      var value = responseDataOpt[optChanged][optChanged];
      urlSearchParams.set(optChanged, value.join(","));
    }
  }

  baseUrl.search = urlSearchParams.toString();
  window.history.replaceState(null, "", baseUrl.toString());
};

export default {
  state,
  getters,
  mutations,
  actions
};
